import React from "react";
import clsx from "clsx/lite";
import { ReactComponent as LoaderIcon } from "svgs/loader.svg";

const Loader = ({ className = "" }) =>
	<div className="flex justify-center">
		<LoaderIcon className={clsx(className, "size-4 text-gray-100 animate-spin fill-[#929D9F]")} />
	</div>;


export default Loader;
